import { useTheme } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';

const useIsMobile = (size = 'md') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(size));
};

export default useIsMobile;
